import React from "react";
import { useTranslation } from "react-i18next";
import { useApp } from "@/contexts";
import { ENTITIES, OPERATION_RIGHTS } from "@/config";
import { EmptyState } from "@/components/generic";

export interface CarsEmptyStateProps {
  /** Callback when user clicks the "Add Vehicle" button (only shown if user has create permission) */
  onCreateCar?: () => void;
  /** Whether the empty state should be displayed */
  display?: boolean;
}

export const CarsEmptyState: React.FC<CarsEmptyStateProps> = ({
  onCreateCar,
  display = true,
}) => {
  const { t } = useTranslation();
  const { hasRightTo } = useApp();

  const canCreate = hasRightTo(ENTITIES.CARS, OPERATION_RIGHTS.CREATE);

  if (canCreate) {
    return (
      <EmptyState
        display={display}
        title={t("common:emptyState.noVehicles.title")}
        description={t("common:emptyState.noVehicles.description")}
        iconName="Car"
        actionLabel={t("common:emptyState.noVehicles.actionLabel")}
        actionIcon="Plus"
        onAction={onCreateCar}
      />
    );
  }

  return (
    <EmptyState
      display={display}
      title={t("common:emptyState.noVehiclesAccess.title")}
      description={t("common:emptyState.noVehiclesAccess.description")}
      iconName="CarOff"
    />
  );
};